import React, { ReactElement } from 'react';

import { BUTTON_TYPES, EvButton, EvLinkTypes, EvTableColumn } from '@evinced-private/ui-common';

import { NAME_NOT_PROVIDED } from 'src/apps/dashboard/constants/Dashboard';
import { IWfaSessionIssue } from 'src/apps/dashboard/types/WfaDashboardServiceTypes';
import { EvLinkLocal } from 'src/common/components/ev-link-local/EvLinkLocal';
import { renderNumberCellFormatter } from 'src/common/components/ev-table/cell-formatters/numberCellFormatter';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

export const getWfaSessionColumns = (): EvTableColumn[] => {
	return [
		{
			dataField: 'sessionName',
			text: 'Session',
			style: { width: '270px' },
			headerStyle: { width: '270px' },
			sort: true,
			formatter: (name: string, session: IWfaSessionIssue) => {
				return (
					<EvLinkLocal
						className="web-sdk-test-name"
						id={session.sessionId}
						url={RoutesHelper.getWfaSessionRootPath(session.sessionId)}
						ariaLabel={`${name} Session`}
						linkText={name || NAME_NOT_PROVIDED}
						type={EvLinkTypes.DARK}
					/>
				);
			}
		},
		{
			dataField: 'criticalIssues',
			text: 'Critical Issues',
			style: { width: '100px' },
			headerStyle: { width: '100px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'seriousIssues',
			text: 'Serious Issues',
			style: { width: '100px' },
			headerStyle: { width: '100px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'totalIssues',
			text: 'Total Issues',
			style: { width: '90px' },
			headerStyle: { width: '90px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'runTime',
			text: 'Date',
			style: { width: '90px' },
			headerStyle: { width: '90px' },
			sort: true,
			formatter: (cell: string): string => formatShortMonthDatetime(cell)
		},
		{
			dataField: 'actions',
			text: 'Actions',
			style: { width: '120px' },
			headerStyle: { width: '120px' },
			formatter: actionFormatter
		}
	];
};

const handleViewDetails = (runId: string): void => {
	const url = RoutesHelper.getWfaSessionRootPath(runId);

	window.open(url, '_blank');
};

const actionFormatter = (_cell: unknown, row: IWfaSessionIssue): ReactElement => (
	<EvButton
		onClick={() => handleViewDetails(row.sessionId)}
		ariaLabel={`View details for ${row.sessionName}`}
		type={BUTTON_TYPES.SECONDARY_WITH_TRANSPARENT_BG}
		title="View Details"
		small
	>
		View Details
	</EvButton>
);
